module.exports = __webpack_public_path__ + "img/two.3936a5b4.png";